module.exports = __webpack_public_path__ + "media/images/icons/star-black-9e081857f869538a3162e398dffa26d9.svg";